var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "16-location"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "linear color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 4C143.514 4 52 95.514 52 208c0 34.837 10.568 72.315 31.412 111.4 16.371 30.695 39.121 62.515 67.619 94.576C199.279 468.251 246.8 504.1 248.8 505.6a12 12 0 0 0 14.4 0c2-1.5 49.521-37.349 97.769-91.627 28.5-32.061 51.248-63.881 67.619-94.576C449.432 280.315 460 242.837 460 208 460 95.514 368.486 4 256 4Zm87.315 393.708A746.674 746.674 0 0 1 256 480.754a746.681 746.681 0 0 1-87.315-83.046C126.4 350.076 76 278.5 76 208c0-99.252 80.748-180 180-180s180 80.748 180 180c0 70.5-50.4 142.076-92.685 189.708Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.041 311.016A155.657 155.657 0 0 0 412 208c0-86.019-69.981-156-156-156s-156 69.981-156 156a156.9 156.9 0 0 0 .931 17.007C109.477 303.266 175.952 364.029 256 364a155.556 155.556 0 0 0 117.041-52.984ZM260 292h-8v-24h8Zm12-48h-32a12 12 0 0 0-12 12v36h-24V124h104v168h-24v-36a12 12 0 0 0-12-12Zm-117.749 48A131.624 131.624 0 0 1 127 236h53v56ZM332 292v-56h53a131.624 131.624 0 0 1-27.252 56ZM256 76c72.785 0 132 59.215 132 132 0 1.339-.026 2.671-.066 4H332V112a12 12 0 0 0-12-12H192a12 12 0 0 0-12 12v100h-55.934c-.04-1.329-.066-2.661-.066-4 0-72.785 59.215-132 132-132Zm-75.806 240h151.612a131.72 131.72 0 0 1-151.612 0Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 244a12 12 0 0 0-12 12v16a12 12 0 0 0 24 0v-16a12 12 0 0 0-12-12ZM160 244a12 12 0 0 0-12 12v16a12 12 0 0 0 24 0v-16a12 12 0 0 0-12-12ZM256 132a12 12 0 0 0-12 12v16a12 12 0 0 0 24 0v-16a12 12 0 0 0-12-12ZM256 196a12 12 0 0 0-12 12v16a12 12 0 0 0 24 0v-16a12 12 0 0 0-12-12ZM288 172a12 12 0 0 0 12-12v-16a12 12 0 0 0-24 0v16a12 12 0 0 0 12 12ZM300 224v-16a12 12 0 0 0-24 0v16a12 12 0 0 0 24 0ZM224 132a12 12 0 0 0-12 12v16a12 12 0 0 0 24 0v-16a12 12 0 0 0-12-12ZM224 196a12 12 0 0 0-12 12v16a12 12 0 0 0 24 0v-16a12 12 0 0 0-12-12Z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateIcon);
export default __webpack_public_path__ + "static/media/state-icon.a6f9d8b4ccd0c86267b7bd9b26b7d034.svg";
export { ForwardRef as ReactComponent };